import CloseIcon from "@mui/icons-material/Close";
import { Box, Divider, Stack, IconButton } from "@mui/material";
import { ContextSwitcher } from "Components/Layout/Menu/ContextSwitcher/ContextSwitcher";
import { useLoggedInUser } from "Hooks/useLoggedInUser";
import { UserActions } from "Components/Layout/Menu/UserMenu/UserActions";
import { UserInfo } from "Components/Layout/Menu/UserMenu/UserInfo";

type Props = {
  onActionTriggered?: () => void;
};

export const UserMenu = ({ onActionTriggered }: Props) => {
  const user = useLoggedInUser();

  if (!user) {
    return null;
  }

  return (
    <Box
      p={3}
      minWidth={280}
      borderRadius={2}
      bgcolor="common.white"
      position="relative"
    >
      <Stack gap={3}>
        <Box display="flex" justifyContent="space-between" gap={3}>
          <Box mt={0} mr={6}>
            <UserInfo user={user} />
          </Box>
          <IconButton
            onClick={onActionTriggered}
            size="small"
            sx={{ position: "absolute", top: 4, right: 4 }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
        <ContextSwitcher onContextSwitched={onActionTriggered} />
        <Divider />
        <UserActions onActionTriggered={onActionTriggered} />
      </Stack>
    </Box>
  );
};
